import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

function ScrollTop() {
  return (
    <div>
      <FontAwesomeIcon
        id='scrolltotop'
        onClick={() => { window.scrollTo(0, 0) }}
        icon={faArrowUp} />
    </div>
  );
}

export default ScrollTop;
